function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 10 6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2 11.5c-.2 0-.4-.1-.6-.2L10 2.4l-8.6 8.8c-.3.3-.8.3-1.1 0S0 10.4.2 10L10 0l9.8 10c.2.2.3.6.2.9-.2.4-.5.6-.8.6z",
  fill: "#5c912e"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
}))), /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.2 11.5c-.2 0-.4-.1-.6-.2L10 2.4l-8.6 8.8c-.3.3-.8.3-1.1 0S0 10.4.2 10L10 0l9.8 10c.2.2.3.6.2.9-.2.4-.5.6-.8.6z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff",
  filter: "url(#a)"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#5c912e",
  d: "M-5-13.71h30v30.9H-5z"
})));

const SvgDownAngle = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 12",
    enableBackground: "new 0 0 20 12",
    ref: svgRef
  }, props), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownAngle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/down-angle.416d9b7e.svg";
export { ForwardRef as ReactComponent };